<!-- 订货详情 -->
<script>
import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';
import formAdd from './formAdd.vue';

formCreate.component('formAdd', formAdd);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      rule: [],
      row: null,
      buttons: {
        submit: false,
      },
    };
  },
  async created() {
    const rule = await this.getFormRule('order_display_form');
    this.reload(rule);
    if (this.formConfig.id) {
      request.post('/kms/kmsorderform/query', { id: this.formConfig.id }).then((res) => {
        this.setValue({
          ...res.result,
          formAdd: res.result.goodsVos,
        });
        this.row = res.result;
      });
    }
  },
};
</script>
